import styled from 'styled-components';

export const DiscountsSave = styled.div`
  position: relative;
  margin-right: 16px;

  &.PublishOverlay {
    z-index: 13;
  }
  .PublishDrop {
    &::after {
      right: 140px;
      @media (max-width: 1650px) {
        right: 90px;
      }
    }
  }
  .ButtonSave {
    min-width: 180px;
    padding: 10px 5px;
    overflow: inherit;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 26px;
      height: 26px;
      z-index: 7;
      flex: 0 0 auto;
      //@media (max-width: 599px) {
      //  width: 24px;
      //  height: 24px;
      //}
    }
    span {
      padding-left: 10px;
      //@media (max-width: 599px) {
      //  display: none;
      //}
    }
    //@media (max-width: 599px) {
    //  width: 44px;
    //  height: 44px;
    //  padding: 9px 5px;
    //}
  }
  @media (max-width: 767px) {
    .PublishDrop {
      right: inherit;
      left: -15px;

      &::after {
        right: inherit;
        left: 80px;
      }
    }
  }
  @media (max-width: 599px) {
    .PublishDrop {
      right: inherit;
      left: 0;

      &::after {
        right: inherit;
        left: 70px;
      }
    }
  }
  @media (max-width: 470px) {
    .PublishDrop {
      left: 50%;
      transform: translateX(-50%);
      &::after {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .IconSpecificItems {
    display: flex;
    align-items: center;
    svg {
      height: 18px;
    }
  }

  .MuiTable-root {
    border-collapse: separate;

    .MuiTableRow-root td:first-child {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .MuiTableRow-root td:last-child {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    tr {
      &:first-child {
        th {
          &:nth-child(2) {
            width: 10%;
          }
        }
      }
    }
  }
`;

export const DiscountsModalSwitch = styled.div`
  box-shadow: 1px -8px 18px 0 #6c31970f, 1px 5px 10px 0 #6c319714;
  border-radius: 10px;
  padding: 30px 23px;
  display: flex;
  margin-bottom: 20px;
  &.mTop17 {
    margin-top: 17px;
  }
  .LeftBlock {
    margin-top: -6px;
    width: 10%;
    margin-right: 20px;
    @media (max-width: 630px) {
      width: 25%;
    }
    .switcher-text {
      color: #929cb9;
    }
  }

  .RightBlock {
    width: 100%;
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 6px;
    }

    .description {
      margin-bottom: 17px;
    }
  }
`;

export const DiscountsModalButton = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default DiscountsSave;
